module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Media-library1-0833d195064412b53584b7104a5b7e6d.svg";